import React from "react";
import { SvgPrint } from "../../../../utils/svgIcons";

const NewPrintButtonClick = ({
  itemToDownloadID,
  ignoreFromPrint,
  pdfOrientation,
}) => {
  // const handleDownload = (printId) => {
  //   const printContent = document.getElementById(printId).innerHTML;
  //   const printWindow = window.open("", "_blank", "width=800,height=600");
  //   const styles = [...document.styleSheets]
  //     .map((style) => {
  //       try {
  //         return style.cssRules
  //           ? [...style.cssRules].map((rule) => rule.cssText).join("\n")
  //           : "";
  //       } catch (error) {
  //         return "";
  //       }
  //     })
  //     .join("\n");

  //   printWindow.document.open();
  //   printWindow.document.write(`
  //           <html>
  //           <head>
  //             <title>Print</title>
  //             <style>${styles}</style>
  //           </head>
  //           <body>${printContent}</body>
  //           </html>
  //       `);

  //   console.log(printContent, "printContent");
  //   printWindow.document.close();
  //   printWindow.focus();
  //   printWindow.print();
  //   printWindow.close();
  // };
// 
  //   const handleDownload = (printId, ignoreIds) => {
  //     const printContent = document.getElementById(printId).innerHTML;
  //     const newWindow = window.open("", "_blank");
  //     newWindow.document.write(`
  //         <html>
  //         <head>
  //             <title>Print</title>
  //             <style>
  //                 /* Add styles if needed */
  //             </style>
  //         </head>
  //         <body>
  //             ${printContent}
  //         </body>
  //         </html>
  //     `);
  //     newWindow.document.close();
  //     newWindow.focus();
  //     newWindow.print();
  //     newWindow.close();
  // };


  const handleDownload = (printId) => {
    const printContent = document.getElementById(printId).cloneNode(true);
  
    // Remove footer if it exists
    const footers = printContent.querySelectorAll("footer");
    footers.forEach((footer) => footer.remove());
  
    const styles = [...document.styleSheets]
      .map((style) => {
        try {
          return style.cssRules
            ? [...style.cssRules].map((rule) => rule.cssText).join("\n")
            : "";
        } catch (error) {
          return "";
        }
      })
      .join("\n");
  
    const printWindow = document.body.innerHTML;
  
    document.body.innerHTML = `
      <html>
        <head>
          <title>Print</title>
          <style>
            ${styles}
            @media print {
              body {
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
              }
            }
          </style>
        </head>
        <body>${printContent.innerHTML}</body>
      </html>
    `;
  
    window.print();
    document.body.innerHTML = printWindow;
    window.location.reload(); // Restore original content
  };
  

  return (
    <div
      onClick={() => handleDownload(itemToDownloadID, ignoreFromPrint)}
      className="cursor_pointer flex align_items_center flex_direction_col"
    >
      <span>
        <SvgPrint color={"#009A50"} />
      </span>

      <span className="color_333">Print</span>
    </div>
  );
};

export default NewPrintButtonClick;
